const vatThresholdWindows = (
  ["rolling12Months", "calendarYear"] as const
).map((e) => e);
export type VatThresholdWindows = (typeof vatThresholdWindows)[0];

export class VatThresholdWindow {
  constructor({ name }: { name: VatThresholdWindows }) {
    this.name = name;
  }

  name: VatThresholdWindows;

  static def: VatThresholdWindow = new VatThresholdWindow({
    name: "rolling12Months",
  });

  static fromString(str: string): VatThresholdWindow {
    const lowerStr = str.replace(/[_-]/g, "").toLowerCase();
    const name = vatThresholdWindows.find((e) => e.toLowerCase() === lowerStr);
    if (name) {
      return new VatThresholdWindow({ name });
    }
    throw new Error("Invalid type of the VAT threshold window.");
  }

  static isValidString(str?: string): boolean {
    const lowerStr = str?.replace(/[_-]/g, "")?.toLowerCase();
    const name = vatThresholdWindows.find((e) => e.toLowerCase() === lowerStr);
    return !!name;
  }

  toString(): string {
    return this.name;
  }
}
